import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Header, Footer, PWAInstallPrompt } from './components/common'
import { Home, Locali, Locale, ComeFunziona, IlClub, Login, Register, Profilo, Segnala } from './pages/public'
import { Dashboard, AdminLocali, AdminLocaleEdit, AdminSegnalazioni, AdminUtenti } from './pages/admin'
import { ProtectedRoute } from './components/auth'
import { AdminLayout } from './components/admin'
import { useAuthStore } from './store'
import NotFound from './pages/NotFound'

/**
 * Layout pubblico con Header e Footer
 */
function PublicLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Header />
      <main className="flex-grow pt-8">
        {children}
      </main>
      <Footer />
    </>
  )
}

/**
 * Componente principale dell'applicazione
 * Gestisce il layout e il routing
 */
export default function App() {
  const { checkAuth } = useAuthStore()

  // Verifica autenticazione al caricamento
  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  return (
    <div className="min-h-screen flex flex-col bg-night">
      <Routes>
        {/* Pagine admin con layout dedicato */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/locali"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout>
                <AdminLocali />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/locali/nuovo"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout>
                <AdminLocaleEdit />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/locali/:id"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout>
                <AdminLocaleEdit />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/segnalazioni"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout>
                <AdminSegnalazioni />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/utenti"
          element={
            <ProtectedRoute requireAdmin>
              <AdminLayout>
                <AdminUtenti />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        {/* Pagine pubbliche con Header/Footer */}
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/locali" element={<PublicLayout><Locali /></PublicLayout>} />
        <Route path="/locale/:slug" element={<PublicLayout><Locale /></PublicLayout>} />
        <Route path="/come-funziona" element={<PublicLayout><ComeFunziona /></PublicLayout>} />
        <Route path="/il-club" element={<PublicLayout><IlClub /></PublicLayout>} />
        <Route path="/segnala" element={<PublicLayout><Segnala /></PublicLayout>} />
        <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
        <Route path="/registrati" element={<PublicLayout><Register /></PublicLayout>} />
        <Route
          path="/profilo"
          element={
            <PublicLayout>
              <ProtectedRoute>
                <Profilo />
              </ProtectedRoute>
            </PublicLayout>
          }
        />

        {/* 404 */}
        <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
      </Routes>

      {/* PWA Install Prompt */}
      <PWAInstallPrompt />
    </div>
  )
}
